import React from "react";
import { Spinner } from "react-bootstrap";

function Loader({ height, width }) {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        height: height || "50px",
        width: width || "50px",
        margin: "auto",
        display: "block",
        color: "#3B596B"
      }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export { Loader };
